import BootstrapTable from "react-bootstrap-table-next";
import { capitalizeFirstLetter, formatDateFr } from "../../lib/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Link, route } from "preact-router";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import { PaginationProvider, PaginationListStandalone } from 'react-bootstrap-table2-paginator';
import { Button } from "react-bootstrap";
import { deleteEmailTemplate, getEmailTemplates } from "../../api/email-templates";

export default function EmailTemplateTable({ templates, onChange, remote = false, onPageChange, page = 1, sizePerPage = 10, totalSize = undefined }) {

    const handleDelete = async (row, e) => {
        e.stopPropagation();

        let confirm = window.confirm("Êtes-vous sûr de vouloir supprimer ce template e-mail ?");

        if (!confirm) {
            return;
        }

        try {
            await deleteEmailTemplate(row.key);
        } catch (error) {
            console.error(error);
            alert("Une erreur est survenue lors de la suppression du template e-mail");
        } finally {
            if (typeof onChange === "function") {
                onChange();
            }
        }

    }

    const columns = [
        {
            dataField: "key",
            text: "#",
            sort: true,
            formatter: (cell, row) => {
                return <code>
                    {cell}
                </code>
            }
        },
        {
            dataField: "created_at",
            text: "Créé à",
            sort: true,
            formatter: (cell, row) => {
                let str = cell ? formatDateFr(cell, true) : "-";

                if (row?.created_by?.email) {
                    str += ` par ${row.created_by.email}`;
                }

                return str;
            }
        },
        {
            dataField: "updated_at",
            text: "MàJ à",
            sort: true,
            formatter: (cell, row) => {
                let str = cell ? formatDateFr(cell, true) : "-";

                if (row?.updated_by?.email) {
                    str += ` par ${row.updated_by.email}`;
                }

                return str;
            }
        },
        {
            dataField: "actions",
            text: "Actions",
            isDummyField: true,
            formatter: (cell, row) => {
                return (
                    <div class="btn-group">
                        <Link href={`/email-templates/save/${row.key}`} class="btn btn-sm btn-primary">
                            <FontAwesomeIcon icon={faPen} />
                        </Link>

                        <Button className="btn btn-sm btn-danger" onClick={(e) => handleDelete(row, e)}>
                            <FontAwesomeIcon icon={faTrash} />
                        </Button>
                    </div>
                );
            },
        }
    ];

    const rowEvents = {
        onClick: (e, row, rowIndex) => {
            e.stopPropagation();
            return route(`/email-templates/save/${row.key}`);
        }
    }

    const handleTableChange = (type, { page, sizePerPage, sortOrder, sortField }) => {
        if (typeof onPageChange === "function") {
            onPageChange({ page, sizePerPage, sortOrder, sortField });
        }
    }

    return (
        <>
            <PaginationProvider
                pagination={paginationFactory(remote ? { custom: true, page, sizePerPage, totalSize, hideSizePerPage: true } : {
                    custom: true,
                    hideSizePerPage: true,
                    totalSize: templates.length,
                    sizePerPage: templates.length
                })}
            >
                {
                    ({
                        paginationProps,
                        paginationTableProps
                    }) => (
                        <>
                            <BootstrapTable
                                rowStyle={{
                                    cursor: 'pointer'
                                }}
                                rowClasses={(row, rowIndex) => {
                                    return 'cursor-pointer animate__animated animate__fadeIn';
                                }}
                                remote={remote}
                                keyField="id"
                                columns={columns}
                                data={templates}
                                onTableChange={remote ? handleTableChange : null}
                                rowEvents={rowEvents}
                                classes={"align-middle"}
                                bordered={false}
                                striped
                                noDataIndication={"Aucun template e-mail trouvé"}
                                {...paginationTableProps}
                            />

                            {totalSize > sizePerPage ? <div className="d-flex justify-content-center">
                                <PaginationListStandalone

                                    {...paginationProps}
                                />
                            </div> : null}
                        </>
                    )
                }
            </PaginationProvider>
        </>
    );

}
